import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import './TextArea.css';

const TextArea = forwardRef(({
    label,
    error,
    helperText,
    fullWidth = true,
    required = false,
    disabled = false,
    rows = 4,
    maxLength,
    showCount = false,
    className = '',
    value = '',
    ...props
}, ref) => {
    const inputId = props.id || props.name || `textarea-${Math.random().toString(36).substr(2, 9)}`;
    const charCount = value?.length || 0;

    return (
        <div className={`textarea-wrapper ${fullWidth ? 'textarea-full' : ''} ${className}`}>
            {label && (
                <label htmlFor={inputId} className="textarea-label">
                    {label}
                    {required && <span className="textarea-required">*</span>}
                </label>
            )}
            <div className="textarea-container">
                <textarea
                    ref={ref}
                    id={inputId}
                    className={`textarea ${error ? 'textarea-error' : ''}`}
                    disabled={disabled}
                    rows={rows}
                    maxLength={maxLength}
                    value={value}
                    {...props}
                />
                {showCount && maxLength && (
                    <span className="textarea-count">{charCount}/{maxLength}</span>
                )}
            </div>
            {(error || helperText) && (
                <span className={`textarea-helper ${error ? 'error' : ''}`}>
                    {error || helperText}
                </span>
            )}
        </div>
    );
});

TextArea.displayName = 'TextArea';

TextArea.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    helperText: PropTypes.string,
    fullWidth: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    rows: PropTypes.number,
    maxLength: PropTypes.number,
    showCount: PropTypes.bool,
    className: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string
};

export default TextArea;
